import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const TextLineSection = ({
  text,
  icon,
  showIcon = true,
  className,
  style,
}: {
  text: string;
  icon?: string;
  showIcon?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={`w-full theme-gradient-green overflow-hidden my-4 ${className}`}
      style={{ ...style }}
    >
      <div className="marquee-animate-line  flex items-center gap-8 h-fit py-1 leading-none w-fit min-w-full">
        {Array.from({ length: 40 }).map((item, index) => (
          <div key={index} className="w-full flex items-center gap-2 py-5">
            <p className="font-size-32px whitespace-nowrap font-Poppins-Medium text-white">
              {text || "Exclusive Deals"}
            </p>
            {showIcon && (
              <>
                {icon || (
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="text-white font-size-18px"
                  />
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TextLineSection;
